import { createAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import {
  claimLineItemSchema,
  crewOrderSchema,
  gspOrderSchema,
  settingsSchema,
} from '~/utils/schemas';

export const completeCrewClaim = createAction('crewClaim/complete');
export const completeShippingProtectionClaim = createAction(
  'shippingProtectionClaim/complete',
);

const orderPayloadSchema = z.union([crewOrderSchema, gspOrderSchema]);

export const setOrder =
  createAction<z.infer<typeof orderPayloadSchema>>('order/setOrder');

export const invalidateLineItem = createAction<string>(
  'draftClaimLineItem/invalidateLineItem',
);

export const completeDraftClaimLineItem = createAction<
  z.infer<typeof claimLineItemSchema>
>('draftClaimLineItem/completeDraftClaimLineItem');

export const reset = createAction<
  | {
      settings: z.infer<typeof settingsSchema>;
    }
  | undefined
>('app/reset');

export const orderEditCommit = createAction('orderEdit/commit');
